import * as Actions from "../redux/partnerSession";
import * as AdminSessionActions from "../redux/adminSession";
import * as OmniDataAPI from "../../data/omniDataAPI";
import * as UserSessionActions from "../redux/userSession";

import { call, put, select, takeLatest } from "redux-saga/effects";
import { getIdByRelationshipType, isValidUUID } from "../../utils/helpers";

import constants from "../../assets/constants";
import { createNewInvite } from "../../data/omniDataModel";
import { createNewUserRelationship } from "../../data/omniDataModel";
import { v4 as uuid } from "uuid";

export function* loadPartnerODM({ payload }) {
  try {
    //clear out the existing information
    yield put(Actions.setPartnerAssessmentsRequest(null));
    yield put(Actions.setPartnerPatientsRequest(null));
    yield put(Actions.setPartnerODMRequest(null));
    if (isValidUUID(payload)) {
      //payload is a valid UUID
      let partnerODM = yield call(OmniDataAPI.getPartner, payload);

      if (partnerODM == null) {
        yield put(Actions.partnerSessionRequestFailed("OmniDataAPI.getPartner FAILED"));
      } else {
        yield put(Actions.setPartnerODMRequest(partnerODM));
        yield put(Actions.loadPartnerODMSuccess());
      }
    } else {
      yield put(Actions.partnerSessionRequestFailed("Bad Partner _id"));
    }
  } catch (error) {
    yield put(Actions.partnerSessionRequestFailed(error));
  }
}

export function* setPartnerODM({ payload }) {
  try {
    //Validate Object if you want

    if (payload == null) {
      //clear out set items
      yield put(Actions.setPartnerAssessmentsRequest(null));
      yield put(Actions.setPartnerPatientsRequest(null));
      yield put(Actions.setPartnerInvitesRequest(null));
    } else {
      //Do all ancillary data loads here
      yield put(Actions.loadPartnerAssessmentsRequest(payload._id));
      yield put(Actions.loadPartnerPatientsRequest(payload._id));
      yield put(Actions.loadPartnerInvitesRequest(payload));
    }

    yield put(Actions.setPartnerODMSuccess(payload));
  } catch (error) {
    yield put(Actions.partnerSessionRequestFailed(error));
  }
}

export function* updatePartner({ payload }) {
  try {
    if (payload._id == null) {
      //CREATE
      payload._id = uuid();
      let newPartner = yield call(OmniDataAPI.createPartner, payload);

      if (newPartner == null) {
        yield put(Actions.partnerSessionRequestFailed("OmniDataAPI.createPartner FAILED"));
      } else {
        yield put(Actions.setPartnerODMRequest(newPartner));
        yield put(Actions.updatePartnerSuccess());
        yield put(AdminSessionActions.reflectUpdatedPartnerODMRequest(newPartner));
      }
    } else if (isValidUUID(payload._id)) {
      //UPDATE
      let newPartner = yield call(OmniDataAPI.updatePartner, payload);
      if (newPartner == null) {
        yield put(Actions.partnerSessionRequestFailed("OmniDataAPI.updatePartner FAILED"));
      } else {
        yield put(Actions.setPartnerODMRequest(newPartner));
        yield put(Actions.updatePartnerSuccess());
        yield put(AdminSessionActions.reflectUpdatedPartnerODMRequest(newPartner));

        // yield put(UserSessionActions.reflectUpdatedUserODMRequest(newPartner));
      }
    } else {
      yield put(Actions.partnerSessionRequestFailed("updatePartner: bad payload"));
    }
  } catch (error) {
    yield put(Actions.partnerSessionRequestFailed(error));
  }
}

export function* deletePartner({ payload }) {
  try {
    //payload is UUID
    if (isValidUUID(payload)) {
      const partner = yield select(Actions.partnerODMSelector);
      let deletedPartner = yield call(OmniDataAPI.deletePartner, payload);
      if (deletedPartner == null) {
        yield put(Actions.deletePartnerSuccess(partner));
        //this method assumes that an ID alone is a delete
        yield put(AdminSessionActions.reflectUpdatedPartnerODMRequest(partner));
      }
    }
    const partnerODM = yield select(Actions.partnerODMSelector);
    if (partnerODM != null && payload === partnerODM._id) {
      yield put(Actions.setPartnerODMRequest(null));
    } else {
      yield put(Actions.partnerSessionRequestFailed("deletePartner: invalid UUID()"));
    }
  } catch (error) {
    yield put(Actions.partnerSessionRequestFailed(error));
  }
}

export function* loadPartnerAssessments({ payload }) {
  try {
    if (isValidUUID(payload)) {
      //payload is a valid UUID

      let assessments = yield call(OmniDataAPI.getAllAssessmentByRelatedID, payload);

      let theReturn = assessments;
      // no longer needed since the return is conditional on one or more single ID being present
      // theReturn = theReturn.reduce((unique, o) => {
      //   if (!unique.some(obj => obj._id === o._id)) {
      //     unique.push(o);
      //   }
      //   return unique;
      // }, []);

      yield put(Actions.loadPartnerAssessmentsSuccess());
      yield put(Actions.setPartnerAssessmentsRequest(theReturn));
    } else {
      yield put(Actions.partnerSessionRequestFailed("loadPartnerAssessments: Invalid UUID"));
    }
  } catch (error) {
    yield put(Actions.partnerSessionRequestFailed(error));
  }
}

export function* setPartnerAssessments({ payload }) {
  try {
    //Validate Object
    yield put(Actions.setPartnerAssessmentsSuccess(payload));
  } catch (error) {
    yield put(Actions.partnerSessionRequestFailed(error));
  }
}

export function* reflectUpdatedAssessmentODM({ payload }) {
  try {
    if (isValidUUID(payload)) {
      const currentList = yield select(Actions.partnerAssessmentsSelector);
      if (currentList != null) {
        //prevents a [] from being returned, thinking this has been initialized from NULL
        const newList = currentList.filter(obj => obj._id !== payload); //creates a copy of the list
        yield put(Actions.reflectUpdatedAssessmentODMSuccess(newList));
      }
    } else {
      const partnerODM = yield select(Actions.partnerODMSelector);
      if (
        partnerODM != null &&
        (partnerODM._id ===
          getIdByRelationshipType(
            payload.omniRelationships.relatedData,
            constants.omniRelationshipTypes.assessmentSubject
          ) ||
          partnerODM._id ===
            getIdByRelationshipType(
              payload.omniRelationships.relatedData,
              constants.omniRelationshipTypes.assessmentProctor
            ))
      ) {
        const currentList = yield select(Actions.partnerAssessmentsSelector);
        const newList =
          currentList == null ? [] : currentList.filter(obj => obj._id !== payload._id); //creates a copy of the list
        newList.push(payload);
        yield put(Actions.reflectUpdatedAssessmentODMSuccess(newList));
      }
    }
  } catch (error) {
    yield put(Actions.partnerSessionRequestFailed(error));
  }
}

export function* loadPartnerPatients({ payload }) {
  try {
    if (isValidUUID(payload)) {
      let allPatients = [];
      allPatients = yield call(OmniDataAPI.getAllPatientsByRelatedId, payload);

      //strip out everything not "patientPartner relationships"
      let partnerPatients = allPatients.filter(obj =>
        obj.omniRelationships.relatedData.some(
          e =>
            e._id === payload &&
            e.omniRelationshipType === constants.omniRelationshipTypes.patientPartner
        )
      );
      //Check for Proxy Patient, this is an optimization, a load patients always gets called
      //there is one of these in provider session too
      let proxyPatient = allPatients.filter(obj =>
        obj.omniRelationships.relatedData.some(
          e =>
            e._id === payload &&
            e.omniRelationshipType === constants.omniRelationshipTypes.proxyPatient
        )
      );

      if (proxyPatient.length > 0) {
        yield put(UserSessionActions.setProxyPatientODMRequest(proxyPatient[0]));
      }

      yield put(Actions.loadPartnerPatientsSuccess());
      yield put(Actions.setPartnerPatientsRequest(partnerPatients));
    } else {
      yield put(Actions.partnerSessionRequestFailed("loadPartnerPatients: Invalid UUID"));
    }
  } catch (error) {
    yield put(Actions.partnerSessionRequestFailed(error));
  }
}

export function* setPartnerPatients({ payload }) {
  try {
    //Validate Object
    // let proxyPatientODM = null;

    if (payload != null) {
      // .filter(obj => obj._id !== payload)
      // for (let index = 0; index < assessmentQuestions.length; ++index) {
      // setProxyPatientODMRequest
      // }
    }

    //this also acts to clear old proxyPatientODMs
    // setProxyPatientODMRequest(null);

    // yield put(Actions.setPartnerPatientsSuccess(payload));
    yield put(Actions.setPartnerPatientsSuccess(payload));
  } catch (error) {
    yield put(Actions.partnerSessionRequestFailed(error));
  }
}

export function* reflectUpdatedPatientODM({ payload }) {
  try {
    if (isValidUUID(payload)) {
      const currentList = yield select(Actions.partnerPatientsSelector);
      if (currentList != null) {
        //prevents a [] from being returned, thinking this has been initialized from NULL
        const newList = currentList.filter(obj => obj._id !== payload); //creates a copy of the list
        yield put(Actions.reflectUpdatedPatientODMSuccess(newList));
      }
    } else {
      const currentList = yield select(Actions.partnerPatientsSelector);
      const newList = currentList == null ? [] : currentList.filter(obj => obj._id !== payload._id); //creates a copy of the list
      newList.push(payload);
      yield put(Actions.reflectUpdatedPatientODMSuccess(newList));

      const currentUserODM = yield select(UserSessionActions.userODMSelector);
      if (
        currentUserODM &&
        payload.omniRelationships.relatedData.some(
          e =>
            e._id === currentUserODM._id &&
            e.omniRelationshipType === constants.omniRelationshipTypes.proxyPatient
        )
      ) {
        yield put(UserSessionActions.setProxyPatientODMRequest(payload));
      }
    }
  } catch (error) {
    yield put(Actions.partnerSessionRequestFailed(error));
  }
}

export function* loadPartnerInvites({ payload }) {
  try {
    if (payload != null) {
      let relatedInvites = [];
      relatedInvites = yield call(OmniDataAPI.getAllInvitesByRelatedId, payload._id);

      if (relatedInvites != null) {
        if (relatedInvites.length === 0) {
          // always create a single valid invite
          // eventually the length check may also need an expired check to create a new one

          let permInvite = createNewInvite(constants.onboardingUserType.partner);

          permInvite.omniData.userData.email = payload.omniData.email;
          permInvite.omniData.userData.mobilePhone = payload.omniData.mobilePhone;
          permInvite.omniData.userData.familyName = payload.omniData.familyName;
          permInvite.omniData.userData.givenName = payload.omniData.givenName;

          permInvite.omniData.inviteType = constants.inviteType.shared;
          permInvite.omniData.target = `Default Shareable Invitation`;

          let newRelationship = createNewUserRelationship(
            payload,
            constants.omniRelationshipTypes.inviteOwner
          );

          permInvite.omniRelationships.relatedData.push(newRelationship);

          let newInvite = yield call(OmniDataAPI.createInvite, permInvite);

          if (newInvite != null) {
            relatedInvites.push(newInvite);
          }

          yield put(Actions.loadPartnerInvitesSuccess());
          yield put(Actions.setPartnerInvitesRequest(relatedInvites));
        } else {
          yield put(Actions.loadPartnerInvitesSuccess());
          yield put(Actions.setPartnerInvitesRequest(relatedInvites));
        }
      } else {
        yield put(Actions.partnerSessionRequestFailed("getAllInvitesByRelatedId: call failed"));
      }
    } else {
      yield put(Actions.partnerSessionRequestFailed("loadPartnerInvites: Invalid UUID"));
    }
  } catch (error) {
    yield put(Actions.partnerSessionRequestFailed(error));
  }
}

export function* setPartnerInvites({ payload }) {
  try {
    //Validate Object
    yield put(Actions.setPartnerInvitesSuccess(payload));
  } catch (error) {
    yield put(Actions.partnerSessionRequestFailed(error));
  }
}

//  saga
export default function* partnerDataSaga() {
  yield takeLatest(Actions.loadPartnerODMRequest, loadPartnerODM);
  yield takeLatest(Actions.setPartnerODMRequest, setPartnerODM);
  yield takeLatest(Actions.updatePartnerRequest, updatePartner);
  yield takeLatest(Actions.deletePartnerRequest, deletePartner);

  yield takeLatest(Actions.loadPartnerAssessmentsRequest, loadPartnerAssessments);
  yield takeLatest(Actions.setPartnerAssessmentsRequest, setPartnerAssessments);
  yield takeLatest(Actions.reflectUpdatedAssessmentODMRequest, reflectUpdatedAssessmentODM);

  yield takeLatest(Actions.loadPartnerPatientsRequest, loadPartnerPatients);
  yield takeLatest(Actions.setPartnerPatientsRequest, setPartnerPatients);
  yield takeLatest(Actions.reflectUpdatedPatientODMRequest, reflectUpdatedPatientODM);

  yield takeLatest(Actions.loadPartnerInvitesRequest, loadPartnerInvites);
  yield takeLatest(Actions.setPartnerInvitesRequest, setPartnerInvites);
}
